export class ApiError extends Error {
  message: string;
  detail?: string;

  constructor(message: string, detail?: string) {
    super(message);
    this.message = message;
    this.detail = detail;
  }

  toString() {
    return this.message;
  }
}

// Used when the backend returns a validation-style error (typically 400 invalidJsonBody)
// and we want to show the backend message inline rather than redirecting to /error.
export class ApiValidationError extends ApiError {
  errorType: string;

  constructor(message: string, errorType: string) {
    super(message);
    this.errorType = errorType;
  }
}
